document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('.open-size-chart');
  const panel = document.querySelector('.size-chart-panel');
  const closeBtn = document.querySelector('.size-chart-close');

  if (openBtn && panel && closeBtn) {
    openBtn.addEventListener('click', () => {
      panel.style.display = 'block';
    });

    closeBtn.addEventListener('click', () => {
      panel.style.display = 'none';
    });

    // Optional: Close if clicked outside
    document.addEventListener('click', (e) => {
      if (!panel.contains(e.target) && !openBtn.contains(e.target)) {
        panel.style.display = 'none';
      }
    });
  }
});
